import gql from 'graphql-tag';

import type { RecentlyUsedTemplate } from 'src/data/template';
import { executeGqlQuery, type GqlCallVariables } from 'src/graphql/client';
import { FRAGMENT_MULTI_PROMPT_TEMPLATE } from 'src/graphql/multiPromptTemplates';
import type { ID } from 'src/lib/collection';
import { getSingleProp } from 'src/lib/graphql';

import { FRAGMENT_SUB_TEMPLATE } from './schema';

const QUERY = gql`
  query RecentlyUsedTemplates($customerId: ID!, $workspaceId: ID!) {
    recentlyUsedTemplates(customerId: $customerId, workspaceId: $workspaceId) {
      type
      generationTool
      subTemplate {
        ...SubTemplate
      }
      customMultiPromptTemplate {
        ...CustomerMultiPromptTemplate
      }
    }
  }
  ${FRAGMENT_SUB_TEMPLATE}
  ${FRAGMENT_MULTI_PROMPT_TEMPLATE}
`;

interface Variables extends GqlCallVariables {
  customerId: ID;
  workspaceId: ID;
}

export const queryRecentlyUsedTemplates = async (variables: Variables) => {
  const { data } = await executeGqlQuery({
    query: QUERY,
    variables,
  });
  return getSingleProp<RecentlyUsedTemplate[]>(data) || [];
};
